import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class JemRoute extends AuthenticatedRoute {}
